import React, { useState } from "react";
import { connect } from "react-redux";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import BootstrapTooltip from "../../toolTip";
import Link from "../../../common/linkWithQuery";
import { generateIntegrationLogCSV } from "../../../utils/helpers";

import { UserDropdownList, UserDropdownItems, SyncStatusIcon } from "../style";

const SyncStatus = ({ accountInfo, accountIntegrationLogs }) => {
  const [expand, setExpand] = useState(false);
  const totalIssues = accountIntegrationLogs?.length || 0;

  return (
    <ClickAwayListener onClickAway={() => setExpand(false)}>
      <UserDropdownList>
        <BootstrapTooltip
          isHide={!totalIssues}
          title="Issue with sync"
          placement="bottom"
        >
          <SyncStatusIcon onClick={() => setExpand((prev) => !prev)}>
            {/* iconSyncInProgress - use later */}
            <div className="iconSync"></div>
            {/* Use later */}
            {/* <div className="subIcon iconCompleted"></div> */}
            <div className={`subIcon ${totalIssues ? "iconError" : ""}`} />
          </SyncStatusIcon>
        </BootstrapTooltip>
        <UserDropdownItems
          visible={expand ? "visible" : "hidden"}
          width="300px"
        >
          {/* TODO - User later */}
          {/* <div
            className="dropdownDetail"
            onClick={() => {
              setExpand(false);
            }}
          >
            Sync Now
          </div> */}
          <div className="dropdownDetail">
            {totalIssues ? (
              <>
                There were {totalIssues} sync issues. &nbsp;
                <Link
                  textDecoration="underlined"
                  onClick={() => {
                    generateIntegrationLogCSV(
                      accountIntegrationLogs,
                      accountInfo?.get("time_zone"),
                    );
                  }}
                  to=""
                >
                  See Sync report
                </Link>
              </>
            ) : (
              <>There is no sync issues.</>
            )}
          </div>
        </UserDropdownItems>
      </UserDropdownList>
    </ClickAwayListener>
  );
};

const mapStateToProps = (state) => ({
  accountIntegrationLogs: state.getIn(["headers", "integrationLogs"]),
  accountInfo: state.getIn(["manageAccount", "accountInfo"]),
});

export default connect(mapStateToProps, null)(SyncStatus);
